import { useParams } from 'react-router';
import { EditorCore } from './Editor';

/** The page of one template: the item editor, on a template's draft (see EditorCore's `source`). */
export function TemplateEditorPage() {
  const { id } = useParams();
  return <EditorCore key={id} source={{ kind: 'template', id: id! }} />;
}
